import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useLogin } from "../../Services/Api";


const Login = () => {
  const navigate = useNavigate();
  const [login, setLogin] = useState('');
  const inputRef = useRef(null);
  const focusTimeout = useRef(null);
  const keyboardTimeout = useRef(null);

  const [lresult, , sendLogin] = useLogin();

  //фокусировка на поле ввода логина, после монтирования компонента и 
  //предохранительная очистка интервалов при размонтировании
  useEffect(() => {
    focusTimeout.current = setTimeout(() => {
      inputRef.current.focus();
    }, 100)
    return () => {
      clearTimeout(focusTimeout.current)
      clearTimeout(keyboardTimeout.current)
    }
  }, [])

  useEffect(() => {
    //проверка результатов запроса логина

    //если вход успешен
    if (lresult && lresult?.payload?.token) {
      localStorage.setItem('token', lresult.payload.token)
      if (lresult?.payload?.userName) localStorage.setItem('userName', lresult.payload.userName)
      if (lresult?.payload?.companyName) localStorage.setItem('companyName', lresult.payload.companyName)
      if (lresult?.payload?.isChief) localStorage.setItem('isChief', lresult.payload.isChief)
      navigate('/')
    }
    //запрос успешен (результат не пустой), а вот вход не успешен
    if (lresult && !lresult?.payload?.token){
      //чистим поле ввода
      setLogin("");
      //и фокусируемся на поле ввода
      inputRef.current.focus();
    }
  }, [lresult])

  const loginHandleChange = (e) => {
    clearTimeout(keyboardTimeout.current)
    //пустые строки мы не шлем в логин
    if(!!e.target.value){
      keyboardTimeout.current = setTimeout(() => {
        sendLogin(e.target.value)
      }, 300);
    }
    setLogin(e.target.value)
  }

  return (
    <div>
      <h2>Отсканируйте ID карту</h2>
      <input type="text" value={login} onChange={loginHandleChange} ref={inputRef} />
    </div>
  )
}

export default Login;